import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../shared/BrandLogo';
import ProductMockup from './ProductMockup';
import AppStoreButtons from '../shared/AppStoreButtons';
import { CREATE_GIFT_PAGE_URL } from '../../constants/appLinks';
import { useScrollToSection } from '../../hooks/useScrollToSection';
import '../../styles/landing/BrandLogo.css';
import '../../styles/landing/HeroSection.css';

const HeroSection: React.FC = () => {
    const { t } = useTranslation();
    const { handleNavClick } = useScrollToSection();

    return (
        <section id="home" className="hero-section" aria-labelledby="hero-heading">
            <div className="hero-section__bg" aria-hidden="true" />
            <div className="hero-section__inner landing-container">
                <div className="hero-section__content">
                    <p className="hero-section__eyebrow">
                        <BrandLogo
                            size={28}
                            wordmarkClassName="hero-section__eyebrow-text"
                        />
                    </p>
                    <h1 id="hero-heading" className="hero-section__title">
                        {t('hero.title')}
                    </h1>
                    <p className="hero-section__subtitle">{t('hero.subtitle')}</p>
                    <div className="hero-section__ctas">
                        <a href={CREATE_GIFT_PAGE_URL} className="btn btn--primary">
                            {t('cta.createGiftPage')}
                        </a>
                        <a
                            href="#how-it-works"
                            className="btn btn--secondary"
                            onClick={(e) => handleNavClick(e, '#how-it-works')}
                        >
                            {t('cta.seeHowItWorks')}
                        </a>
                    </div>
                    <AppStoreButtons className="hero-section__stores" />
                </div>
                <ProductMockup />
            </div>
        </section>
    );
};

export default HeroSection;
